export interface ChartPointsData {
    accessNumber: number;
    loginNumber: number;
    date: Date;
}